module.exports = __webpack_public_path__ + "static/media/billboard_top.8f5da644.svg";